import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/fiscal-profile')({
  component: FiscalProfilePage,
})

function FiscalProfilePage(): JSX.Element {
  return <div>Perfil fiscal — placeholder</div>
}
